'use strict';

const placements = {
  SHOW_ON_HOVER : 'SHOW_ON_HOVER',
  SHOW_ALWAYS: 'SHOW_ALWAYS',
  DONT_SHOW: 'DONT_SHOW'
};

export default {
  placements,
  SIDE_BAR_WIDTH : 430,
  STORE_SIDE_BAR_WIDTH : 560,
  MOBILE_PADDING : 120,
  NO_PADDING : 0
}



// WEBPACK FOOTER //
// ./components/consts.js